import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteVideoUplaod = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        title: "",
        description: "",
        filePath: "",
        fileName: "",
        instituteBoardMappingId: '',
        instituteStreamormediumMappingId: '',
        tagMasterId: '',
        instituteGradeMasterIds: ['']
    }
    const [formData, setFormData] = useState([])
    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [tag, setTag] = useState([])
    const [gradeList, setGradeList] = useState([])

    const [play, setPlay] = useState(false)
    const [played, setPlayed] = useState(0);
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isFullScreen, setFullScreen] = useState(false);
    const playerRef = useRef(null);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [mediumSort, setMediumSort] = useState(null);
    const [tagSort, setTagSort] = useState(null);
    const [videoNameSort, setVideoNameSort] = useState(null);
    const [videoTitleSort, setVideoTitleSort] = useState(null);
    const [videoDescriptionSort, setVideoDescriptionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteBoardMappingDetails.boardMasterDetails.boardName", "instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName", "instituteVideoMasterDetails.instituteGradeMasterDetails.gradeName", "tagMasterDetails.tagName", "fileName", "title", "description"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleFullScreenToggle = () => {
        if (playerRef.current) {
            setFullScreen(!isFullScreen);
            playerRef.current.toggleFullscreen();
        }
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getBoard();
        getTag();
        getGrade();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getVideoList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (PdfBookData.instituteBoardMappingId !== '') {
            setPdfBookList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-video-list?instituteMasterId=${instituteMasterId}&`;
        if (PdfBookData.instituteBoardMappingId !== '') {
            apiUrl += `instituteBoardMappingId=${PdfBookData.instituteBoardMappingId}&`;
        }
        if (PdfBookData.instituteStreamormediumMappingId !== '') {
            apiUrl += `instituteStreamormediumMappingId=${PdfBookData.instituteStreamormediumMappingId}&`;
        }
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }
        if (PdfBookData.instituteGradeMasterIds.length != 0) {
            apiUrl += `instituteGradeMasterIds=${PdfBookData.instituteGradeMasterIds}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (PdfBookData.instituteBoardMappingId !== '') {
            getVideoList();
        }
    }, [PdfBookData.instituteBoardMappingId, PdfBookData.instituteStreamormediumMappingId, PdfBookData.instituteGradeMasterIds, PdfBookData.tagMasterId]);

    const getVideoList = async () => {
        if (PdfBookData.instituteBoardMappingId !== '') {
            try {
                const response = await authorizedAxiosInstitute.get(getApiUrl())
                setPdfBookList(response.data.result);
            } catch (error) {
                setPdfBookList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getBoard = () => {
        const apiUrl = `/institute-wise-board-stream?instituteId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setFormData(response.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getTag = () => {
        const apiUrl = `/get-institute-tag-master?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGrade = () => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result.map((sub) => {
                    return {
                        value: sub.id,
                        label: sub.gradeName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions?.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterIds: selectedIds,
            }
        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-video`;
                const response = await authorizedAxiosInstitute.post(apiUrl, PdfBookData);
                await getVideoList();
                setPdfBookData(prevData => ({
                    ...prevData,
                    filePath: '',
                    fileName: '',
                    title: '',
                    description: ''
                }))

                setSaveId(response.data.result.id);
                setMediumSort(null);
                setTagSort(null);
                setVideoNameSort(null);
                setVideoTitleSort(null);
                setVideoDescriptionSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-video?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                await getVideoList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setTagSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (tagSort == true || tagSort == false) {
            setMediumSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [tagSort])

    useEffect(() => {
        if (videoNameSort == true || videoNameSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoNameSort])

    useEffect(() => {
        if (videoTitleSort == true || videoTitleSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoNameSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoTitleSort])

    useEffect(() => {
        if (videoDescriptionSort == true || videoDescriptionSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
        }
    }, [videoDescriptionSort])

    const handleInputReset = () => {
        setPdfBookData(initialFormState);
        setEditId('');
        setPdfBookList([]);
        setError(initialErrorState);

        setMediumSort(null);
        setTagSort(null);
        setVideoNameSort(null);
        setVideoTitleSort(null);
        setVideoDescriptionSort(null);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Upload Video</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-file-pdf"></i>Institute Upload Video </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteBoardMappingId' onChange={handleInputChange} value={PdfBookData.instituteBoardMappingId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boards?.map((board) => {
                                                                return <option value={board.id}>{board.boardMasterDetails.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteBoardMappingId && <p style={{ color: 'red' }}>{error.instituteBoardMappingId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteStreamormediumMappingId' onChange={handleInputChange} value={PdfBookData.instituteStreamormediumMappingId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streams?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamOrMediumMasterDetails.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteStreamormediumMappingId && <p style={{ color: 'red' }}>{error.instituteStreamormediumMappingId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={gradeList.filter(option =>
                                                            PdfBookData.instituteGradeMasterIds && PdfBookData.instituteGradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterIds"
                                                        options={gradeList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.instituteGradeMasterIds && <p style={{ color: 'red' }}>{error.instituteGradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="filePath" value={PdfBookData.filePath} onChange={handleInputChange} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>

                                                <CModal
                                                    backdrop="static"
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    className={isFullScreen ? "full_scr_view" : ""}
                                                >
                                                    <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                                                    <div className="test test-player">
                                                        <ReactPlayer
                                                            ref={playerRef}
                                                            url={showPdfLink}
                                                            playing={play}
                                                            volume={volume}
                                                            onProgress={handleProgress}
                                                            playbackRate={playbackRate}
                                                        >
                                                        </ReactPlayer>
                                                        <div className="overlay-layer">
                                                            <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                                                        </div>
                                                    </div>
                                                    <div className="video_content_bottom">
                                                        <div className="video_progress">
                                                            <input
                                                                type="range"
                                                                min={0}
                                                                max={1}
                                                                step="any"
                                                                value={played}
                                                                onChange={handleSeekChange}
                                                                className="input_slider"
                                                            />
                                                        </div>

                                                        <div className='play_pause_sound'>
                                                            <div className='sound'>
                                                                {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                                                    <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                                                                {volume >= 0.5 && <button className='play_pause_btn'>
                                                                    <i class="fa fa-volume-high"></i>
                                                                </button>}
                                                                {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                                                    <i class="fa fa-volume-low"></i>
                                                                </button>}
                                                                {volume == 0 && <button className='play_pause_btn'>
                                                                    <i class="fa fa-volume-xmark"></i>
                                                                </button>}

                                                                <div className='sound_bar'>
                                                                    <input
                                                                        type="range"
                                                                        value={volume}
                                                                        onChange={handleVolumeChange}
                                                                        min="0"
                                                                        max="1"
                                                                        step="0.01"
                                                                        className="input_slider"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='playbeack_speed'>
                                                                <span>Playback speed</span>
                                                                <select onClick={handleSpeedChange}>
                                                                    <option value={0.25}>0.25</option>
                                                                    <option value={0.5}>0.5</option>
                                                                    <option value={0.75}>0.75</option>
                                                                    <option selected value={1}>Normal</option>
                                                                    <option value={1.25}>1.25</option>
                                                                    <option value={1.5}>1.5</option>
                                                                    <option value={1.75}>1.75</option>
                                                                </select>
                                                            </div>
                                                            <div className='fullscreen_mode'>
                                                                <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CModal>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container"> {/* Added Flexbox class */}
                                                    {!editId && (
                                                        <button className="btn btn-primary" type="button" onClick={addLesson}>
                                                            Save
                                                        </button>
                                                    )}
                                                    <button className="btn btn-danger delete_icon" type="reset" onClick={handleInputReset}>
                                                        Reset
                                                    </button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Board</th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">
                                                                            Tag
                                                                            <SortIcon sortState={tagSort} setSortState={setTagSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Name
                                                                            <SortIcon sortState={videoNameSort} setSortState={setVideoNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"fileName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Title
                                                                            <SortIcon sortState={videoTitleSort} setSortState={setVideoTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Description
                                                                            <SortIcon sortState={videoDescriptionSort} setSortState={setVideoDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Video</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson?.instituteBoardMappingDetails?.boardMasterDetails.boardName}</td>
                                                                                        <td>{lesson?.instituteStreamormediumMappingDetails?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                        <td>{lesson?.instituteVideoMasterDetails.map((i) => `${i.instituteGradeMasterDetails.gradeName}`).join(", ")}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson?.fileName}</td>
                                                                                        <td>{lesson?.title}</td>
                                                                                        <td>{lesson?.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>

                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Video Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteVideoUplaod;